import { useParams, useSearchParams } from 'react-router';
import { ProductDetail } from './ProductDetail';
import { BundleDetail } from './BundleDetail';

export function ProductDetailPage() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  return <ProductDetail key={id} id={id!} openPackaging={searchParams.get('panel') === 'packaging'} />;
}

export function BundleDetailPage() {
  const { id } = useParams();
  return <BundleDetail key={id} id={id!} />;
}
